import React from "react";
import dayjs from "dayjs";
import {
  COLLABORATOR_COMMENT_LABEL,
  FINAL_INTERVIEW_LABEL,
  CM_STATE_SHEET_ARCHIVED_LABEL,
  FORMATION_LABEL,
  INTERNAL_GRADE_LABEL,
  SOFT_SKILLS_LABEL,
  PROJECTS_LABEL,
  COLLABORATOR_PROFILE_LABEL,
  A_LEGEND_LABEL,
  B_LEGEND_LABEL,
  C_LEGEND_LABEL,
  D_LEGEND_LABEL,
  DAY_LABEL,
  DAYS_LABEL,
  WEEK_LABEL,
  WEEKS_LABEL,
  MONTHS_LABEL,
  YEARS_LABEL,
  MONTH_LABEL,
  YEAR_LABEL,
  HOUR_LABEL,
  HOURS_LABEL,
  CM_STATE_SHEET_ARCHIVED_WITH_TERMINATION_LABEL,
  SKILLS_LABEL,
  PROFESSIONAL_PORTRAIT_LABEL,
  TO_VERIFY_LABEL,
  READY_TO_SEND_LABEL,
  OTHER_LABEL,
  DIPLOMA_LABEL,
  DEGREE_LABEL,
  MASTER_DEGREE_LABEL,
  MASTER_LABEL,
  DOCTORATE_LABEL,
  CM_STATE_PLANNING_LABEL,
  CM_STATE_PROGRESS_LABEL,
  CM_STATE_FINAL_CONSIDERATIONS_LABEL,
  CM_STATE_EVALUATION_LABEL,
  QUADRANT_LABEL_HIGH_POTENTIAL,
  QUADRANT_LABEL_GROWTH_POTENTIAL,
  QUADRANT_LABEL_POTENTIAL_IN_CURRENT_ROLE,
  QUADRANT_LABEL_ROLE_CONTEXT_NOT_ALIGNED,
  JUNIOR_CONSULTANT_LABEL,
  CONSULTANT_LABEL,
  SENIOR_CONSULTANT_LABEL,
  MANAGER_LABEL,
  SENIOR_MANAGER_LABEL,
  NO_LABEL,
  TO_EVALUATE_LABEL,
  YES_LABEL,
} from "./Dictionary";
import {
  CollaboratorIncreasingEnum,
  ScreenEnum,
} from "../types/api/collaborators.type";
import { theme } from "./StyledComponents";
import { SelectOption } from "../components/core/Select/Select";

export enum StatusCodes {
  BAD_REQUEST_ERROR = 400,
  UNAUTHORIZED = 401,
  CUSTOM_ERROR = 409,
  FORBIDDEN = 403,
}

export const COLLABORATORS_PAGE_SIZE = 10;
export const CAREER_MANAGERS_PAGE_SIZE = 10;
export const CAREER_MANAGERS_FOLLOWED_PAGE_SIZE = 10;
export const COURSES_PAGE_SIZE = 10;
export const CERTIFICATIONS_PAGE_SIZE = 10;
export const TECH_SKILLS_PAGE_SIZE = 10;
export const MATRIX_COLLABORATORS_PAGE_SIZE = 30;
export const CONFIG_COLLABORATORS_PAGE_SIZE = 10;
export const COLLABORATORS_TECH_SKILLS_PAGE_SIZE = 10;
export const HISTORY_PROJECT_ROLES_PAGE_SIZE = 10;
export const FORMATION_COLLABORATORS_PAGE_SIZE = 10;
export const NOTIFICATIONS_PAGE_SIZE = 5;
export const MATRIX_COLLABORATORS_EXAMINED_PAGE_SIZE = 10;
export const HISTORY_PROJECT_SECTORS_PAGE_SIZE = 10;
export const HISTORY_PROJECT_COMPANY_PAGE_SIZE = 10;

export const currentYear = dayjs().year();
export const previousYear = dayjs().subtract(1, "year").year();

export const CHARACTER_MAX_LENGTH = 5000;

export enum CollaboratorTypeEnum {
  FOLLOW = "FOLLOW",
  ACTIVE = "ACTIVE",
}

export enum CmSheetMenuEnum {
  INTERNAL_GRADE = "Internal Grade",
  SOFT_SKILLS = "Soft Skills",
  GOALS = "Goals",
  DEVELOPMENT = "Development",
  PROFESSIONAL_PATH = "Professional Path",
  FORMATION = "Formation",
  COLLABORATOR_COMMENT = "Collaborator Comment",
  FINAL_INTERVIEW = "Final Interview",
  ADMIN_COMMENT = "ADMIN Comment",
  NOTE = "Note",
}

export enum ProfessionalHistoryMenuEnum {
  COLLABORATOR_PROFILE = "Profilo del Collaboratore",
  PROJECTS = "Progetti",
  PROFESSIONAL_PORTRAIT = "Ritratto Professionale",
  FORMATION = "Formation",
  SKILLS = "Competenze",
}

export enum ConfigMenuEnum {
  INTERNAL_GRADE = "Internal Grade",
  SOFT_SKILLS = "Soft Skills",
  //GOALS = "Goals",
  COLLABORATOR_COMMENT = "Collaborator Comment",
  FINAL_INTERVIEW = "Final Interview",
}

export const professionalHistoryMenu: ProfessionalHistoryMenuEnum[] = [
  ProfessionalHistoryMenuEnum.COLLABORATOR_PROFILE,
  ProfessionalHistoryMenuEnum.PROFESSIONAL_PORTRAIT,
  ProfessionalHistoryMenuEnum.SKILLS,
  ProfessionalHistoryMenuEnum.FORMATION,
  ProfessionalHistoryMenuEnum.PROJECTS,
];

export const professionalHistoryMenuLabels: {
  [key in ProfessionalHistoryMenuEnum]: string;
} = {
  [ProfessionalHistoryMenuEnum.PROFESSIONAL_PORTRAIT]:
    PROFESSIONAL_PORTRAIT_LABEL,
  [ProfessionalHistoryMenuEnum.PROJECTS]: PROJECTS_LABEL,
  [ProfessionalHistoryMenuEnum.COLLABORATOR_PROFILE]:
    COLLABORATOR_PROFILE_LABEL,
  [ProfessionalHistoryMenuEnum.FORMATION]: FORMATION_LABEL,
  [ProfessionalHistoryMenuEnum.SKILLS]: SKILLS_LABEL,
};

export const configMenuLabels: { [key in ConfigMenuEnum]: string } = {
  [ConfigMenuEnum.INTERNAL_GRADE]: INTERNAL_GRADE_LABEL,
  [ConfigMenuEnum.SOFT_SKILLS]: SOFT_SKILLS_LABEL,
  //[ConfigMenuEnum.GOALS]: GOALS_LABEL,
  [ConfigMenuEnum.COLLABORATOR_COMMENT]: COLLABORATOR_COMMENT_LABEL,
  [ConfigMenuEnum.FINAL_INTERVIEW]: FINAL_INTERVIEW_LABEL,
};

export enum TabMenuCollaborator {
  PROFESSIONAL_HISTORY = 0,
  CM_SHEET = 1,
  RESUME = 2,
}

export enum TabMenuManagement {
  ORGANIZATIONAL_CHART = 0,
  CM_SHEET = 1,
  ACTIVE_RESOURCES = 2,
  ARCHIVING = 3,
}

export const configMenu: ConfigMenuEnum[] = [
  ConfigMenuEnum.INTERNAL_GRADE,
  //ConfigMenuEnum.GOALS,
  ConfigMenuEnum.SOFT_SKILLS,
  ConfigMenuEnum.COLLABORATOR_COMMENT,
  ConfigMenuEnum.FINAL_INTERVIEW,
];

export enum FormationTypeEnum {
  INSTRUCTION = "INSTRUCTION",
  COURSE = "COURSE",
  CERTIFICATION = "CERTIFICATION",
}

export enum InternalGradePagesEnum {
  JOB_FAMILIES = "JOB_FAMILIES",
  PATHS_GRADES = "PATHS_GRADES",
  SUBGRADES = "SUBGRADES",
}

export enum DevelopmentTypeEnum {
  INDICATORS = "INDICATORS",
  COMMENTS = "COMMENTS",
}

export const PerformanceCategoryLabels: Record<ScreenEnum, string> = {
  [ScreenEnum.A]: A_LEGEND_LABEL,
  [ScreenEnum.B]: B_LEGEND_LABEL,
  [ScreenEnum.C]: C_LEGEND_LABEL,
  [ScreenEnum.D]: D_LEGEND_LABEL,
};

export const screens = [
  {
    value: "A",
    label: "High performer",
  },
  {
    value: "B",
    label: "Crescita superiore alla media",
  },
  {
    value: "C",
    label: "Crescita nella media",
  },
  {
    value: "D",
    label: "Low performer",
  },
];

export enum CollaboratorContractTypeEnum {
  ALTRF = "PARTNER",
  DIPEND = "INTERNI",
  INT = "SOMMINISTRATI",
  EXTERNAL = "ESTERNI",
}

export enum TimestampLabelEnum {
  hour = "hour",
  day = "day",
  week = "week",
  month = "month",
  year = "year",
}

export const timespanLabels: Record<
  TimestampLabelEnum,
  { singular: string; plural: string }
> = {
  hour: { singular: HOUR_LABEL, plural: HOURS_LABEL },
  day: { singular: DAY_LABEL, plural: DAYS_LABEL },
  week: { singular: WEEK_LABEL, plural: WEEKS_LABEL },
  month: { singular: MONTH_LABEL, plural: MONTHS_LABEL },
  year: { singular: YEAR_LABEL, plural: YEARS_LABEL },
};

export enum PermissionsEnum {
  SIDEBAR_MATRIX = "sidebar_matrix",
  SIDEBAR_MANAGE_CAREER = "sidebar_manage_career",
  SIDEBAR_COLLABORATORS = "sidebar_collaborators",
  SIDEBAR_AREA_DEVELOPMENT = "sidebar_area_development",
  SIDEBAR_TECH_SKILLS = "sidebar_tech_skills",
  SIDEBAR_FORMATION = "sidebar_formation",
  SIDEBAR_MANAGEMENT = "sidebar_management",
  SIDEBAR_PERSONAL_PROFILE = "sidebar_personal_profile",
  SIDEBAR_ORG = "sidebar_org",
  EDIT_RESUME = "edit_resume",
  EDIT_TECH_FORMATION = "edit_tech_formation",
  HISTORY_CM = "history_cm",
  CHANGE_STATUS_SM_SHEET = "change_status_sm_sheet",
  EDIT_OWN_CM_SHEET = "edit_own_cm_sheet",
  EDIT_PROFESSIONAL_PATH_CM_SHEET = "edit_professional_path_cm_sheet",
  EDIT_DEVELOPMENT_INDICATORS_CM_SHEET = "edit_development_indicators_cm_sheet",
  EDIT_DEVELOPMENT_BUSINESS_COMMENT_CM_SHEET = "edit_development_business_comment_cm_sheet",
  EDIT_DEVELOPMENT_INCREASINGS_CM_SHEET = "edit_development_increasings_cm_sheet",
  EDIT_DEVELOPMENT_FEEDBACK_TO_COLLABORATOR_CM_SHEET = "edit_development_feedback_to_collaborator_cm_sheet",
  EDIT_ALL_CM_SHEETS = "edit_all_cm_sheets",
  EDIT_CM = "edit_cm",
  EDIT_ADMIN_COMMENT = "edit_admin_comment",
  VIEW_MATRIX_PRACTICE_SELECT = "view_matrix_practice_select",
  CAN_START_CALIBRATION = "can_start_calibration", //da rimuovere
  READ_CM_SHEET_WHEN_ARCHIVED_WITH_TERMINATION = "read_cm_sheet_when_archived_with_termination",
  RESTORE_CM_SHEET = "restore_cm_sheet",
  CAN_DOWNLOAD_CV_ACTIVE_RESOURSES = "can_download_cv_active_resources",
  CAN_DOWNLOAD_CV_COLLABORATOR_PROFILE = "can_download_cv_collaborator_profile",
  APPROVE_COLLABORATOR_CV = "approve_collaborator_cv",
  EDIT_COLLABORATOR_HISTORY = "edit_collaborator_history",
  ENABLE_HISTORY_STATS = "enable_history_stats",
  CAN_DELETE_ASSIGN_CM = "delete_assign_cm",
  VIEW_MATRIX_COMPETENCE_SELECT = "view_competence_select",
  CAN_START_DEVELOPMENT_COMMITTEE = "can_start_development_committee",
  VIEW_GOAL_PERCENTAGE_ACHIEVEMENT = "view_goal_percentage_achievement",
}

export enum CustomerErrorCodesEnum {
  CMSHEETS_NOT_CLOSED = "CMSHEETS_NOT_CLOSED",
  DUPLICATED_ENTITY = "DUPLICATED_ENTITY",
  TECH_SKILL_DUPLICATED_PROPERTY = "TECH_SKILL_DUPLICATED_PROPERTY",
  RELATED_PROJECTS_TIMELINE_OUT_OF_EXPERIENCE_RANGE = "RELATED_PROJECTS_TIMELINE_OUT_OF_EXPERIENCE_RANGE",
  RELATED_PROJECTS_FOUND = "RELATED_PROJECTS_FOUND",
  ABSTRACT_EXPERIENCE_OVERLAP = "ABSTRACT_EXPERIENCE_OVERLAP",
}

export enum CollaboratorRelationTypeEnum {
  INTERNAL = "COLLABORATORE_INTERNO",
  EXTERNAL = "COLLABORATORE_ESTERNO",
}

export enum CmSheetStateEnum {
  DRAFT = "DRAFT",
  INTERMEDIATE_EVALUATION = "VALUTAZIONE_INTERMEDIA",
  FINAL_CALIBRATION = "CALIBRATION_FINALE",
  FINAL_FEEDBACK = "FEEDBACK_FINALE",
  ARCHIVED_SHEET = "ARCHIVIATA",
  ARCHIVED_SHEET_WITH_TERMINATION = "CESSAZIONE",
}

export enum CmSheetEventEnum {
  VALUTA = "VALUTA",
  CONCLUDI_SCHEDA = "CONCLUDI_SCHEDA",
  INVIA_FEEDBACK = "INVIA_FEEDBACK",
  ARCHIVIA = "ARCHIVIA",
  TERMINA = "TERMINA",
  RICHIEDI_PRESA_VISIONE = "RICHIEDI_PRESA_VISIONE",
  OK_PRESA_VISIONE = "OK_PRESA_VISIONE",
  BACKTO_FEEDBACK_FINALE = "BACKTO_FEEDBACK_FINALE",
  BACKTO_CALIBRATION_FINALE = "BACKTO_CALIBRATION_FINALE",
  BACKTO_VALUTAZIONE_INTERMEDIA = "BACKTO_VALUTAZIONE_INTERMEDIA",
  BACKTO_DRAFT = "BACKTO_DRAFT",
  RESTORE = "RESTORE",
}

export const cmSheetStatesOrdered: CmSheetStateEnum[] =
  Object.values(CmSheetStateEnum);

export const cmSheetStatusLabels: { [key in CmSheetStateEnum]: string } = {
  [CmSheetStateEnum.DRAFT]: CM_STATE_PLANNING_LABEL,
  [CmSheetStateEnum.INTERMEDIATE_EVALUATION]: CM_STATE_PROGRESS_LABEL,
  [CmSheetStateEnum.FINAL_CALIBRATION]: CM_STATE_EVALUATION_LABEL,
  [CmSheetStateEnum.FINAL_FEEDBACK]: CM_STATE_FINAL_CONSIDERATIONS_LABEL,
  [CmSheetStateEnum.ARCHIVED_SHEET]: CM_STATE_SHEET_ARCHIVED_LABEL,
  [CmSheetStateEnum.ARCHIVED_SHEET_WITH_TERMINATION]:
    CM_STATE_SHEET_ARCHIVED_WITH_TERMINATION_LABEL,
};

export enum VerificationStatusEnum {
  DRAFT = "DRAFT",
  PENDING = "PENDING",
  VERIFIED = "VERIFIED",
}

export const VERIFICATION_STATUS_LABELS: Record<
  VerificationStatusEnum,
  string
> = {
  [VerificationStatusEnum.DRAFT]: "Bozza",
  [VerificationStatusEnum.PENDING]: "Da Approvare",
  [VerificationStatusEnum.VERIFIED]: "Approvato",
};

export const VERIFICATION_STATUS_COLORS: Record<
  VerificationStatusEnum,
  string
> = {
  [VerificationStatusEnum.DRAFT]: theme.colors.grey_5,
  [VerificationStatusEnum.PENDING]: theme.colors.yellow_2,
  [VerificationStatusEnum.VERIFIED]: theme.colors.green_2,
};

export type SliderField = {
  title: string;
  key?: string;
};

export type LanguageGroup = {
  groupLabel: string;
  icon: React.ReactNode;
  skills: SliderField[];
};

export enum ArchivingTypeEnum {
  FINAL_FEEDBACK_PENDING = "FINAL_FEEDBACK_PENDING",
  READY_SEND_SHEET = "READY_SEND_SHEET",
}

export enum ManageStatusCmSheet {
  READY_TO_SEND = "READY_TO_SEND",
  TO_VERIFY = "TO_VERIFY",
}

export const MANAGE_STATUS_CM_SHEET_LABELS: Record<
  ManageStatusCmSheet,
  string
> = {
  [ManageStatusCmSheet.READY_TO_SEND]: READY_TO_SEND_LABEL,
  [ManageStatusCmSheet.TO_VERIFY]: TO_VERIFY_LABEL,
};

export const MANAGE_STATUS_CM_SHEET_COLORS: Record<
  ManageStatusCmSheet,
  string
> = {
  [ManageStatusCmSheet.READY_TO_SEND]: theme.colors.green_2,
  [ManageStatusCmSheet.TO_VERIFY]: theme.colors.yellow_2,
};

export enum EducationEnum {
  OTHER = "Altro",
  DIPLOMA = "Diploma",
  DEGREE = "Laurea",
  MASTER_DEGREE = "Laurea Magistrale",
  MASTER = "Master",
  DOCTORATE = "Dottorato",
}

export const EDUCATIONS_OPTIONS: SelectOption<string>[] = [
  { value: EducationEnum.OTHER, label: OTHER_LABEL },
  { value: EducationEnum.DIPLOMA, label: DIPLOMA_LABEL },
  { value: EducationEnum.DEGREE, label: DEGREE_LABEL },
  { value: EducationEnum.MASTER_DEGREE, label: MASTER_DEGREE_LABEL },
  { value: EducationEnum.MASTER, label: MASTER_LABEL },
  { value: EducationEnum.DOCTORATE, label: DOCTORATE_LABEL },
];

export enum DownloadFormatEnum {
  PDF = "Pdf",
  WORD = "Word",
  PPT = "Ppt",
}

export const DOWNLOAD_FORMAT: Record<DownloadFormatEnum, string> = {
  [DownloadFormatEnum.PDF]: "pdf",
  [DownloadFormatEnum.WORD]: "docx",
  [DownloadFormatEnum.PPT]: "pptx",
};

export const RefreshReactQuery = {
  HIGH: 0,
  MODERATE: 1000 * 5,
  INFINITY: Infinity,
};

const PERSONAL_PROFILE_INFO_LINK =
  "https://idoqsrl.sharepoint.com/sites/HR-Amministrazione/SitePages/Career-Program-2026.aspx?source=https%3a//idoqsrl.sharepoint.com/sites/HR-Amministrazione/SitePages/Forms/AllPages.aspx&isSPOFile=1&xsdata=MDV8MDJ8fGZlYTYxNTMxZGE3YzQ5MDhjNzY0MDhkZWU4YTQzMmU0fDVmNGM4MGMwNThlZTRlODA4OTkwYjgwZTg1YWQ5ZTVifDB8MHw2MzkyMDM5ODkwNTkzMjM3NDh8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T2pVMk1qbGlaRGxrTFRVMU1tWXRORFl3WlMwNVpqQTNMVGRrTVRabU9USTNZakEzWVY4M00yVTNaamswWkMxbFpHUTNMVFE0Tm1JdE9UQTBOQzA1T1RRNE9UazRNVFk0WXpWQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjNE5EZ3dNakV3TXprNE5nPT18YThiNTAwMjY1NmUwNDE1MjZiYTgwOGRlZThhNDMyZTR8ZTUxM2RiYzczNzZhNDM2NTk3ZmZlYmEzM2RmNzNjMjg%3D&sdata=djVMUy9TRFFPVmVZcGVydE9NcnRXU0JLcTRGNlM4NXIxRUdNU25OazR1UT0%3D&ovuser=5f4c80c0-58ee-4e80-8990-b80e85ad9e5b%2Cgiacomo.defeo%40abstract.it";

const CM_SHEET_SLIDE_INFO_LINK =
  "https://idoqsrl.sharepoint.com/:f:/r/teams/CareerProgram/Documenti%20condivisi/General/Career%20Program%202026?csf=1&web=1&e=2Lt70T&xsdata=MDV8MDJ8fDY1Nzc3ZDMxNzQ0ZDQ5MDRkZWExMDhkZWU4YTNlZmVkfDVmNGM4MGMwNThlZTRlODA4OTkwYjgwZTg1YWQ5ZTVifDB8MHw2MzkyMDM5ODc5MzU4NDkwOTB8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T2pVMk1qbGlaRGxrTFRVMU1tWXRORFl3WlMwNVpqQTNMVGRrTVRabU9USTNZakEzWVY4M00yVTNaamswWkMxbFpHUTNMVFE0Tm1JdE9UQTBOQzA1T1RRNE9UazRNVFk0WXpWQWRXNXhMbWRpYkM1emNHRmpaWE12YldWemMyRm5aWE12TVRjNE5EZ3dNVGs1TVRRMU5nPT18ZDJlMWUzYzMwOTJmNDMwZTQ4MjQwOGRlZThhM2VmZWR8NzcwNTRmYjNkMzZhNGNiZmJjZTYyZDg2ZTE1NDMwYzY%3D&sdata=cUJYcEoyNkF3NzBndjNLSmRkVzE0K1p3RHFWUXg2ZTJDQ0U3V1NIZENUZz0%3D&ovuser=5f4c80c0-58ee-4e80-8990-b80e85ad9e5b%2Cgiacomo.defeo%40abstract.it";

export const CM_SHEET_SLIDE_INFO_LINKS: Partial<
  Record<CmSheetMenuEnum, string>
> = {
  [CmSheetMenuEnum.INTERNAL_GRADE]: CM_SHEET_SLIDE_INFO_LINK,
  [CmSheetMenuEnum.SOFT_SKILLS]: CM_SHEET_SLIDE_INFO_LINK,
  [CmSheetMenuEnum.GOALS]: CM_SHEET_SLIDE_INFO_LINK,
  [CmSheetMenuEnum.PROFESSIONAL_PATH]: CM_SHEET_SLIDE_INFO_LINK,
  [CmSheetMenuEnum.DEVELOPMENT]: CM_SHEET_SLIDE_INFO_LINK,
};

export const PERSONAL_PROFILE_SLIDE_INFO_LINKS: Partial<
  Record<CmSheetMenuEnum, string>
> = {
  [CmSheetMenuEnum.INTERNAL_GRADE]: PERSONAL_PROFILE_INFO_LINK,
  [CmSheetMenuEnum.SOFT_SKILLS]: PERSONAL_PROFILE_INFO_LINK,
  [CmSheetMenuEnum.GOALS]: PERSONAL_PROFILE_INFO_LINK,
  [CmSheetMenuEnum.PROFESSIONAL_PATH]: PERSONAL_PROFILE_INFO_LINK,
  [CmSheetMenuEnum.DEVELOPMENT]: PERSONAL_PROFILE_INFO_LINK,
};

export enum NotificationsTab {
  ALL = "ALL",
  READ = "READ",
  UNREAD = "UNREAD",
}

export enum TabMenuPotentialMatrixV3 {
  DEVELOPMENT = 0,
  PERFORMANCE = 1,
  GENERAL = 2,
}
export const MATRIX_TYPE_FILENAME: Record<TabMenuPotentialMatrixV3, string> = {
  [TabMenuPotentialMatrixV3.DEVELOPMENT]: "development",
  [TabMenuPotentialMatrixV3.PERFORMANCE]: "performance",
  [TabMenuPotentialMatrixV3.GENERAL]: "general",
};

export const QUADRANT_LABELS: Record<ScreenEnum, string> = {
  [ScreenEnum.A]: QUADRANT_LABEL_HIGH_POTENTIAL,
  [ScreenEnum.B]: QUADRANT_LABEL_GROWTH_POTENTIAL,
  [ScreenEnum.C]: QUADRANT_LABEL_POTENTIAL_IN_CURRENT_ROLE,
  [ScreenEnum.D]: QUADRANT_LABEL_ROLE_CONTEXT_NOT_ALIGNED,
};

export const INTERNAL_GRADE_META: Record<
  string,
  { label: string; color: string }
> = {
  JUNIOR_CONSULTANT: {
    label: JUNIOR_CONSULTANT_LABEL,
    color: theme.colors.orange_2,
  },
  CONSULTANT: { label: CONSULTANT_LABEL, color: theme.colors.red_4 },
  SENIOR_CONSULTANT: {
    label: SENIOR_CONSULTANT_LABEL,
    color: theme.colors.purple_7,
  },
  MANAGER: { label: MANAGER_LABEL, color: theme.colors.green_4 },
  SENIOR_MANAGER: { label: SENIOR_MANAGER_LABEL, color: theme.colors.blue_2 },
};

export type InternalGradeKey = keyof typeof INTERNAL_GRADE_META;

export const INTERNAL_GRADE_LABEL_TO_KEY: Record<string, InternalGradeKey> = {
  "1 - Junior Consultant": "JUNIOR_CONSULTANT",
  "2 - Consultant": "CONSULTANT",
  "3 - Senior Consultant": "SENIOR_CONSULTANT",
  "4 - Manager": "MANAGER",
  "5 - Senior Manager": "SENIOR_MANAGER",
};

export const INTERNAL_GRADE_LIST = Object.keys(
  INTERNAL_GRADE_META,
) as InternalGradeKey[];

export enum CareerDevelopmentCommitteeTypeEnum {
  CC_MANAGER = "CC_MANAGER",
  CC_LEADER = "CC_LEADER",
  COLLABORATORS = "COLLABORATORS",
}
export const COLLABORATOR_INCREASE_LABELS: Record<
  CollaboratorIncreasingEnum,
  string
> = {
  [CollaboratorIncreasingEnum.YES]: YES_LABEL,
  [CollaboratorIncreasingEnum.NO]: NO_LABEL,
  [CollaboratorIncreasingEnum.ANALYSIS_REQUIRED]: TO_EVALUATE_LABEL,
};
